import React from 'react';
import styled from 'styled-components';
import { remCalc } from '@lux/helpers';
import logo from '../../assets/images/verisign.png';
var StyledImg = styled.img.withConfig({
  displayName: "VeriSignLogo__StyledImg",
  componentId: "sc-pxioyz-0"
})(["height:", ";margin-bottom:", ";"], remCalc(44), remCalc(8));
var VeriSignLogo = function VeriSignLogo() {
  return /*#__PURE__*/React.createElement(StyledImg, {
    src: logo,
    alt: ''
  });
};
export default VeriSignLogo;